import {
  Participation,
  ParticipationUpdateData,
  useParticipation,
  useSession,
} from '@app/api';
import { CenteredModal } from '@app/core';
import { useCallback } from 'react';
import { ParticipationQuotaUpdate } from './ParticipationQuotaUpdate';
import { useNavigate } from 'react-router-dom';
import { Trans } from 'react-i18next';
import { MutationOptions } from 'react-query';

interface Props {
  isOpen: boolean;
  onRequestClose: () => any;
  participation?: Participation;
  mutationOptions?: MutationOptions<
    Participation,
    Error,
    Participation,
    Participation | ParticipationUpdateData
  >;
}

export const QuotaUpdateModal = ({
  participation,
  isOpen,
  onRequestClose,
  mutationOptions,
}: Props) => {
  const navigate = useNavigate();
  const { data: refreshedParticipation } = useParticipation(participation?.id);
  const { data: session } = useSession(participation?.sessionId);

  const onClose = useCallback(() => {
    onRequestClose();
  }, [onRequestClose]);

  const onAccept = useCallback(() => {
    refreshedParticipation &&
      mutationOptions?.onMutate?.(refreshedParticipation);
    onRequestClose();
    navigate(`part/${refreshedParticipation?.id}`);
  }, [navigate, onRequestClose, mutationOptions, refreshedParticipation]);

  return (
    <CenteredModal
      isOpen={isOpen}
      title={
        <Trans
          i18nKey="sessions.details.monitoring.quota.increase"
          components={{
            b: <b />,
          }}
        />
      }
      onRequestClose={onClose}
    >
      <ParticipationQuotaUpdate
        withTitle={false}
        participation={refreshedParticipation}
        recruitmentId={session?.recruitmentId}
        onAccept={onAccept}
        onCancel={onClose}
        mutationOptions={mutationOptions}
      />
    </CenteredModal>
  );
};
